<script>
import baseMixin from '@/mixins/baseMixin'
import ClientLevel from '@/constants/client/ClientLevel'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ClientDetailsLink',
  mixins: [baseMixin],
  props: {
    clientId: {
      type: Number,
      default: -1,
    },
    groupId: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    ...mapGetters({
      getClient: 'client/getClient',
      getGroup: 'client/getGroup',
    }),
    isGroupIdSet() {
      return this.groupId != null && this.groupId > -1
    },
    isClientIdSet() {
      return this.clientId != null && this.clientId > -1
    },
    clientLevel() {
      return this.isClientIdSet
        ? ClientLevel.CLIENT
        : this.isGroupIdSet
        ? ClientLevel.GROUP
        : ClientLevel.CLIENT
    },
    title() {
      switch (this.clientLevel) {
        case ClientLevel.CLIENT:
          return this.getClient(this.clientId).name
        case ClientLevel.GROUP:
          return this.getGroup(this.groupId).name
        default:
          return ''
      }
    },
    url() {
      switch (this.clientLevel) {
        case ClientLevel.CLIENT:
          return this.returnClientUrl(this.clientId)
        case ClientLevel.GROUP:
          return this.returnClientGroupUrl(this.groupId)
        default:
          return ''
      }
    },
  },
  mounted() {
    switch (this.clientLevel) {
      case ClientLevel.CLIENT:
        this.pokeClient(this.clientId)
        break
      case ClientLevel.GROUP:
        this.pokeGroup(this.groupId)
        break
    }
  },
  methods: {
    ...mapActions({
      pokeClient: 'client/pokeClient',
      pokeGroup: 'client/pokeGroup',
    }),
  },
}
</script>

<template>
  <span>
    <BaseLink
      v-if="isEmbedded"
      :href="url"
      data-testid="title-embedded"
      allow-insecure
      @click.stop
      >{{ title }}</BaseLink
    >
    <span v-else data-testid="title-non-embedded">{{ title }}</span>
  </span>
</template>
